<template lang="html">
  <section class="app-sidebar" v-if="panelRolHeader.modulos">
    <nav 
    :class="{'active': 
      this.sliderMovil,
      'sidebar': true,
      'sidebar-offcanvas': true}"
    id="sidebar">
      <ul class="nav">

        <li class="nav-item" @click="cerrarSliderMovil()" v-if="panelRolHeader.modulos.clientes.accesos">
          <router-link 
          :class="{'active': 
          this.$route.name == 'cliente' || 
          this.$route.name == 'panel_sucursales',
          'nav-link': true}" 
          to="/panel" >
            <i class="menu-icon mdi mdi mdi mdi-account-star"></i>
            <span class="menu-title">Clientes</span>
          </router-link>
        </li>

       
        <li class="nav-item" @click="cerrarSliderMovil()" v-if="panelRolHeader.modulos.empleados.accesos">
          <router-link
          :class="{'active': 
          this.$route.name == 'empleado'
          || this.$route.name == 'empleadoNuevo',
          'nav-link': true}" 
          to="/empleados">

            <i class="menu-icon mdi mdi mdi mdi-account-multiple"></i>
            <span class="menu-title">Equipo</span>
          </router-link>
        </li>

        <li class="nav-item" @click="cerrarSliderMovil()" v-if="panelRolHeader.modulos.roles.accesos">
          <router-link 
          :class="{'active': 
          this.$route.name == 'panel_rol'
          || this.$route.name == 'panel_rolnuevo',
          'nav-link': true}" 
          to="/panel_roles" >
            <i class="menu-icon mdi mdi mdi mdi-account-key"></i>
            <span class="menu-title">Roles</span>
          </router-link>
        </li>

    
      </ul>
    </nav>
  </section>
</template>

<script lang="js">
import { mapGetters, mapActions } from "vuex";
import JQuery from 'jquery'
// eslint-disable-next-line
let $ = JQuery
export default {
  name: 'app-sidebar',
  mounted () {
    
    $('.sidebar-icon-only .sidebar .nav .nav-item').on('mouseenter', function () {
      var $this = $(this)
      $this.addClass('hover-open')
      $this.find('.nav-link').addClass('hover-open')
    })
    $('.sidebar-icon-only .sidebar .nav .nav-item').on('mouseleave', function () {
      var $this = $(this)
      $this.removeClass('hover-open')
      $this.find('.nav-link').removeClass('hover-open')
    })
  },
  data(){
    return{
      sliderMovil: false
    }
  },
  created() {
  
  },
  watch: {
    'panelRolHeader': function(val){
      this.validarAccesosRoles();
    },
    '$route.name'(){
      console.log('APP $route.name admin: ', this.$route.name);
      this.validarAccesosRoles();
    },
  },
  computed: {
    ...mapGetters(["panelRolHeader", 'usuario']),
   
  },
  methods: {
    cerrarSliderMovil(){
      $('#sidebar').toggleClass('active')
    },
    checarAccesoAUrl(nombre){
      //console.log("TCL: checarAccesoAUrl -> nombre", nombre)
      let status = true
      if(nombre == "panel" && !this.panelRolHeader.modulos.clientes.accesos){
        status = false
      }
      if(nombre == "panel_sucursales" && !this.panelRolHeader.modulos.sucursales.accesos){
        status = false
      }if((nombre == "empleados" 
      || nombre == "empleado" 
      || nombre == "empleadoNuevo") && !this.panelRolHeader.modulos.empleados.accesos){
        status = false
      }if((nombre == "panel_roles"
      || nombre == "panel_rolnuevo" 
      || nombre == "panel_rol") && !this.panelRolHeader.modulos.roles.accesos){
        status = false
      }
      return status;
    },
    redirigirLogin(panelRolHeader){
      // console.log("TCL: redirigirLogin -> panelRolHeader", panelRolHeader)
      if(panelRolHeader.modulos.clientes.accesos){
        return '/panel'
      }if(panelRolHeader.modulos.empleados.accesos){
        return '/empleados'
      }if(panelRolHeader.modulos.roles.accesos){
        return '/panel_roles'
      }
    },
    validarAccesosRoles(){
      if(this.usuario){
        if(this.usuario.id !== 'DzFeyylmESMWe8oCRal51vs9Tzt2'){
          console.log('TCL: checar permiso rol')
          if(this.panelRolHeader.info){
            //console.log('TCL: ROUTE PATH :',this.$route.name)
            let permisoUrl = this.checarAccesoAUrl(this.$route.name);
            //console.log('TCL: PermisoUrl:',permisoUrl)
            if(!permisoUrl){
              this.$router.push(this.redirigirLogin(this.panelRolHeader))
            }
          }
        }
      }
    }
  },
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/partials/AppSidebarAdmin.vue